import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { SharedInterfaceBadgeTransactions } from "../../home/transactions/badges/sharedInterface";
import {
  asfTransactionsDepartmentListAsync,
  selectAsfTransactionsListStatus,
} from "../../home/transactions/transactionsSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";

export const TransactionsBadges = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);
  const asfTransactionsDepartmentListStatus = useAppSelector(
    selectAsfTransactionsListStatus,
  );

  useEffect(() => {
    if (department && asfTransactionsDepartmentListStatus === "idle") {
      void dispatch(asfTransactionsDepartmentListAsync(department.uuid));
    }
  }, [dispatch, department, asfTransactionsDepartmentListStatus]);

  if (params.tab !== "badges") {
    return;
  }

  return <SharedInterfaceBadgeTransactions />;
};
